<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Change Job Partition</h4>
  <i style="z-index: 1"
     class="bi bi-x-lg text-danger"
     color="warn"
     (click)="onCancel()"
     title="Close"></i>
</div>
<div class="modal-body text-grey">
  <form name="jobForm" [formGroup]="jobForm">
    <mat-form-field appearance="fill">
      <mat-label>Select Partition</mat-label>
      <mat-select formControlName="job_Partition" required>
        <mat-option *ngFor="let partition of partitions" [value]="partition">
          {{ partition }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="
          jobForm.get('job_Partition').touched &&
          jobForm.get('job_Partition').errors
        ">Please Select Partition.</mat-error>
    </mat-form-field>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button type="button"
          class="btn btn-primary"
          (click)="onSubmit(jobForm)"
          cdkFocusInitial>
    Submit
  </button>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="jobPartition"></ngx-spinner>
